import React from 'react';
import { Capacitor } from '@capacitor/core';

const Footer = () => {
  // Website-only footer — the native app shell hides it (iOS has no footer).
  if (Capacitor.isNativePlatform()) return null;
  return (
    <footer className="bg-gray-900 text-white py-2 px-4 border-t border-gray-800">
      <div className="max-w-6xl mx-auto">
        <div className="text-center">
          <div className="text-xs text-gray-400 leading-tight">
            <span className="text-red-500 font-semibold">CheF SKN</span> • Food & Retail Delivery across St. Kitts & Nevis. Serving Basseterre, Frigate Bay, Bird Rock, Sandy Point, Dieppe Bay, Tabernacle, Charlestown Nevis. © 2024
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
